module.exports = __webpack_public_path__ + "img/1F4A8.c14217d6.svg";